import React from "react";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { formatDayMonth } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import { useSelector, useDispatch } from "react-redux";
import {
  getListDuNoChoVay,
  updateDataSearch,
} from "../../../../actions/DuNoChoVay";
export const SearchBarMobile = () => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchDuNoChoVay);

  const updateState = (field, value) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: value,
      })
    );
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
    console.log(evt);
  };

  const onSearch = () => {
    dispatch(getListDuNoChoVay(dataSearch));
  };

  // convert sự kiện tìm kiếm từ ngày đến ngày
  var dateFrom = currentDate();
  if (dataSearch.dateFrom === "01/01/2001") dateFrom = "";
  else dateFrom = dataSearch.dateFrom;
  var dateTo = currentDate();
  if (dataSearch.dateTo === "01/01/4000") dateTo = "";
  else dateTo = dataSearch.dateTo;
  dateTo = convertDate(dateTo);
  dateFrom = convertDate(dateFrom);
  return (
    <>
      <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
        <div data-repeater-list="car">
          <div data-repeater-item className="">
            <form className="search-full form row bg-search-form form-mobile-search">
              <div className="text-right left-search search-p mb-1 ">
                <div className="search-mobile-new">
                  <div className="container">
                    <div className="row">
                      <div style={{ width: "38%", marginRight: "5px" }}>
                        <DateTimePicker
                          value={dateFrom}
                          onChange={onChangeDate("dateFrom")}
                          placeholder="Từ ngày"
                          name="dateFrom"
                        ></DateTimePicker>
                      </div>
                      <div style={{ width: "38%", marginRight: "5px" }}>
                        <DateTimePicker
                          value={dateTo}
                          onChange={onChangeDate("dateTo")}
                          placeholder="Đến ngày"
                          name="dateFrom"
                        ></DateTimePicker>
                      </div>
                      <div style={{ width: "20%" }}>
                        <button
                          type="submit"
                          className="btn btn-info-new"
                          onClick={onSearch}
                          style={{
                            width: "100%",
                            height: "93%",
                            marginTop: "1px",
                          }}
                        >
                          <i className="la la-search"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* <fieldset className="form-group position-relative mb-0">
                    <input
                      type="text"
                      className="form-control input-sm"
                      id="iconLeft1"
                      placeholder="Tên, Sđt chủ nợ ..."
                    />
                    <div className="form-control-position">
                      <i className="mdi mdi-magnify"></i>
                    </div>
                  </fieldset> */}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
